if(!customElements.get('custom-calendly-popup-trigger')){
    class CustomCalendlyPopupTrigger extends HTMLElement {
        constructor(){
            super();

            this.retries = 0;
            // Kept short: a fallback window.open() only succeeds while the
            // click's user-activation is still fresh (~a few seconds in
            // most browsers). Blocked scripts never "become ready" later
            // anyway, so there's no benefit to waiting longer here.
            this.maxRetries = 10;
            this.retryDelay = 50;
        }

        connectedCallback(){
            this.url = this.dataset.url;

            var trigger = this.querySelector('.calendly-popup-trigger');

            if(!this.url || !trigger){
                return;
            }

            trigger.addEventListener('click', () => {
                this.retries = 0;
                this.waitForCalendly();
            });
        }

        waitForCalendly(){
            if(window.Calendly && typeof window.Calendly.initPopupWidget === 'function'){
                window.Calendly.initPopupWidget({
                    url: this.url,
                    prefill: this.buildPrefill()
                });
                return;
            }

            if(this.retries >= this.maxRetries){
                window.open(this.url, '_blank', 'noopener');
                return;
            }

            this.retries++;
            setTimeout(() => this.waitForCalendly(), this.retryDelay);
        }

        buildPrefill(){
            var prefill = {};

            if(this.dataset.prefillName){
                prefill.name = this.dataset.prefillName;
            }

            if(this.dataset.prefillEmail){
                prefill.email = this.dataset.prefillEmail;
            }

            return prefill;
        }
    }

    customElements.define('custom-calendly-popup-trigger', CustomCalendlyPopupTrigger);
}
